<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Sentiment Model Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-validate="'required|min:3'"
                data-vv-name="title"
                :error-messages="errors.collect('title')"
                v-model="item.name"
                label="Title">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-select
                label="Language"
                :items="languages"
                v-validate="'required'"
                data-vv-name="language"
                :error-messages="errors.collect('language')"
                v-model="item.language">
                </v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                label="Base Sentiment Model"
                :items="sentimentModels"
                data-vv-name="base model"
                v-validate="'required'"
                :error-messages="errors.collect('base model')"
                v-model="item.baseModel">
                </v-select>
              </v-flex>
            </v-layout>
            <h2 class="font-weight-regular" >Model Settings</h2>
            <v-layout row>
              <v-flex xs6>
                <v-select
                label="Annotation Work"
                :items="annotationWorks"
                v-validate="'required'"
                data-vv-name="annotation work"
                :error-messages="errors.collect('annotation work')"
                v-model="item.config.annotationWork">
                </v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                label="Golden Annotation Work"
                :items="annotationWorks"
                v-validate="'required'"
                data-vv-name="golden annotation work"
                :error-messages="errors.collect('annotation work')"
                v-model="item.config.goldenAW">
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs2>
                <v-text-field
                  class="mt-1"
                  min="0"
                  max="5"
                  step="0.1"
                  type="number"
                  label="Positive F1 Increase"
                  v-validate="'required|min_value:0|max_value:5|decimal'"
                  prefix="%"
                  v-model="item.config.posThreshold"
                  data-vv-name="positive f1 threshold"
                  :error-messages="errors.collect('positive f1 threshold')"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  class="mt-1"
                  min="0"
                  max="5"
                  step="0.1"
                  type="number"
                  v-validate="'required|min_value:0|max_value:5|decimal'"
                  label="Neutral F1 Increase"
                  prefix="%"
                  v-model="item.config.neutThreshold"
                  data-vv-name="neutral f1 threhsold"
                  :error-messages="errors.collect('neutral f1 threshold')"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field
                  class="mt-1"
                  min="0"
                  max="5"
                  step="0.1"
                  type="number"
                  v-validate="'required|min_value:0|max_value:5|decimal'"
                  label="Negative F1 Increase"
                  prefix="%"
                  v-model="item.config.negThreshold"
                  data-vv-name="negative f1 threshold"
                  :error-messages="errors.collect('negative f1 threhsold')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-checkbox
                label="Show Advanced Settings"
                color="primary"
                v-model="showAdvanced">
                </v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row v-if="showAdvanced">
              <v-flex >
                <v-text-field
                  class="mt-1"
                  min="0"
                  step="1"
                  type="number"
                  v-validate="'required|min_value:4|numeric'"
                  label="Minimum Positive Label"
                  v-model="item.config.minPosLabel"
                  data-vv-name="positive label"
                  :error-messages="errors.collect('positive label')"
                ></v-text-field>
              </v-flex>
              <v-flex >
                <v-text-field
                  class="mt-1"
                  min="0"
                  step="1"
                  type="number"
                  v-validate="'required|min_value:4|numeric'"
                  label="Minimum Neutral Label"
                  v-model="item.config.minNeutLabel"
                  data-vv-name="neutral label"
                  :error-messages="errors.collect('neutral label')"
                ></v-text-field>
              </v-flex>
              <v-flex >
                <v-text-field
                  class="mt-1"
                  min="0"
                  step="1"
                  type="number"
                  label="Minimum Negative Label"
                  v-validate="'required|min_value:4|numeric'"
                  v-model="item.config.minNegLabel"
                  data-vv-name="negative label"
                  :error-messages="errors.collect('negative label')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row v-if="showAdvanced">
              <v-flex>
                <v-text-field
                  class="mt-1"
                  min="0"
                  max="0.1"
                  step="0.001"
                  type="number"
                  label="Learning Rate"
                  v-validate="'required|min_value:0|max_value:0.1|decimal'"
                  v-model="item.config.learningRate"
                  data-vv-name="learning rate"
                  :error-messages="errors.collect('learning rate')"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  class="mt-1"
                  min="2"
                  max="50"
                  step="1"
                  type="number"
                  label="Epoch Size"
                  v-validate="'required|min_value:2|numeric'"
                  v-model="item.config.epochSize"
                  data-vv-name="epoch size"
                  :error-messages="errors.collect('epoch size')"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 class="text-xs-center">
                <v-switch
                  :label="item.config.trainAll ? 'Train entire network' : 'Train only final layer'"
                  v-model="item.config.trainAll"
                ></v-switch>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'sentiment-model-item',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
    }
    this.axios.get('/annotation-works', {
      params: {
        sentiment: true
      }
    })
      .then(response => {
        this.annotationWorks = response.data.map((aw) => { return {text: aw.name, value: aw.id} })
        this.axios.get('/sentiment-models').then(response => {
          var custom = response.data.custom_models.map((sm) => {
            return {text: sm.name, value: sm.id}
          })
          custom = custom.filter(e => e.value !== this.id)
          this.sentimentModels = custom
          this.axios.get(`/languages`)
            .then(response => {
              this.languages = response.data.map((ds) => { return {text: ds.name, value: ds.id} })
              if (!this.isNew) {
                this.fetchSentimentModelItem()
              }
            })
            .catch(error => {
              this.handleAxiosError(error)
            })
        })
      })
  },
  data () {
    return {
      item: {
        id: '',
        language: '',
        name: '',
        baseModel: '',
        config: {
          annnotationWork: undefined,
          goldenAW: undefined,
          minPosLabel: 30,
          minNeutLabel: 30,
          minNegLabel: 30,
          posThreshold: 1,
          neutThreshold: 1,
          negThreshold: 1,
          epochSize: 2,
          learningRate: 0.001,
          trainAll: true
        }
      },
      saveLoading: false,
      showAdvanced: false,
      annotationWorks: [],
      sentimentModels: [],
      languages: []
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    ...mapState({
    })
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchSentimentModelItem () {
      this.axios.get(`/sentiment-models/${this.id}`)
        .then(response => {
          this.setSentimentModelItem(response.data)
        })
        .catch((error) => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setSentimentModelItem (item) {
      this.item.id = item.id
      this.item.name = item.name
      this.item.language = item.language.id
      if (item.base_model) {
        this.item.baseModel = item.base_model
      } else {
        if (this.item.language === 'tr') {
          this.item.baseModel = this.sentimentModels.find(x => x.value === 1)
        } else {
          this.item.baseModel = this.sentimentModels.find(x => x.value === 2)
        }
      }
      this.item.config.annotationWork = item.config.annotation_work
      this.item.config.goldenAW = item.config.golden_aw
      this.item.config.minPosLabel = item.config.min_positive_label_sz
      this.item.config.minNeutLabel = item.config.min_neutral_label_sz
      this.item.config.minNegLabel = item.config.min_negative_label_sz
      this.item.config.posThreshold = item.config.pos_f_score_threshold * 100
      this.item.config.neutThreshold = item.config.neut_f_score_threshold * 100
      this.item.config.negThreshold = item.config.neg_f_score_threshold * 100
      this.item.config.epochSize = item.config.epoch_size
      this.item.config.learningRate = item.config.learning_rate
      this.item.config.trainAll = item.config.train_all_layers
    },
    save () {
      this.saveLoading = true
      var itemToSave = {}
      itemToSave.name = this.item.name
      itemToSave.language = this.item.language
      console.log(this.item.baseModel.value)
      if (this.item.baseModel.value !== 1 && this.item.baseModel.value !== 2 &&
          this.item.baseModel !== 1 && this.item.baseModel !== 2) {
        itemToSave.base_model = this.item.baseModel
      }
      itemToSave.config = {}
      itemToSave.config.annotation_work = this.item.config.annotationWork
      itemToSave.config.golden_aw = this.item.config.goldenAW
      itemToSave.config.min_positive_label_sz = this.item.config.minPosLabel
      itemToSave.config.min_neutral_label_sz = this.item.config.minNeutLabel
      itemToSave.config.min_negative_label_sz = this.item.config.minNegLabel
      itemToSave.config.pos_f_score_threshold = this.item.config.posThreshold / 100
      itemToSave.config.neut_f_score_threshold = this.item.config.neutThreshold / 100
      itemToSave.config.neg_f_score_threshold = this.item.config.negThreshold / 100
      itemToSave.config.epoch_size = this.item.config.epochSize
      itemToSave.config.learning_rate = this.item.config.learningRate
      itemToSave.config.train_all_layers = this.item.config.trainAll

      if (this.isNew) {
        this.axios.post('/sentiment-models', itemToSave)
          .then(response => {
            this.$toast.open({text: 'Sentiment Model successfully saved.', type: 'success'})
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/sentiment-models/${this.item.id}`, itemToSave)
          .then(response => {
            this.$toast.open({text: 'Sentiment Model successfully saved.', type: 'success'})
            this.$router.go(-1)
          })
          .catch((error) => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    saveLoading (val) {
      this.setLoader({
        loading: val
      })
    }
  }
}
</script>

<style>

</style>
